import React from "react";
import { motion } from "framer-motion";

export default function ProfileStatsBar({ user, totalParticipants, openTaskCount, maxPoints }) {
  const remaining = maxPoints - (user?.total_points || 0);
  const initials = (user?.full_name || user?.email || "?")
    .split(" ")
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <section
      dir="rtl"
      className="relative overflow-hidden"
      style={{ background: "#0d0d0d", padding: "40px 16px" }}
    >
      {/* Subtle glow */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
        style={{ width: "946px", height: "108px", background: "rgba(200,241,53,0.1)", filter: "blur(40px)", borderRadius: "189px" }}
      />

      <div className="max-w-5xl mx-auto relative z-10">
        <div className="flex flex-wrap gap-4 items-stretch justify-center">
          {/* User card */}
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            className="rounded-2xl flex flex-col items-center justify-center gap-3 flex-[2] min-w-[200px]"
            style={{ background: "#111", minHeight: "158px", padding: "20px" }}
          >
            <div
              className="w-20 h-20 rounded-full flex items-center justify-center text-2xl font-bold text-black"
              style={{ background: "linear-gradient(135deg, #c8f135, #a3e635)" }}
            >
              {initials}
            </div>
            <p className="text-lg font-semibold text-white">{user?.full_name || user?.email}</p>
          </motion.div>

          {/* Prize card */}
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.05 }}
            className="rounded-2xl flex flex-col items-center justify-center gap-1 flex-[2] min-w-[200px]"
            style={{ background: "#111", minHeight: "158px", padding: "20px" }}
          >
            <img src="/images/giveaway/world_cup_trophy.png" alt="גביע" className="w-6 h-6 object-contain" />
            <p
              className="text-2xl font-semibold text-center leading-tight"
              style={{
                background: "linear-gradient(3deg, #806731, #917844, #ccb686, #f0dcaf, #ffebbf)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              זוג כרטיסים
            </p>
            <p
              className="text-base font-semibold text-center"
              style={{
                background: "linear-gradient(3deg, #806731, #917844, #ccb686, #f0dcaf, #ffebbf)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              למשחק הפתיחה של המונדיאל
            </p>
            <div className="flex items-center gap-3 mt-1">
              <img src="/images/giveaway/usa_flag.png" alt="USA" className="w-6 h-6 rounded-full object-cover" />
              <span className="text-white font-semibold text-lg">{`ארה"ב  -  פרגוואי`}</span>
              <img src="/images/giveaway/paraguay_flag.png" alt="Paraguay" className="w-6 h-6 rounded-full object-cover" />
            </div>
          </motion.div>

          {/* Points card */}
          <StatCard
            label="נקודות"
            value={user?.total_points || 0}
            sublabel={`${remaining} נק׳ לסיום`}
            delay={0.1}
          />

          {/* Tasks card */}
          <StatCard
            label="משימות"
            value={openTaskCount}
            sublabel="משימות פתוחות"
            delay={0.15}
          />

          {/* Ranking card */}
          <StatCard
            label="דירוג"
            value={`#${user?.rank || "-"}`}
            sublabel={`מתוך ${totalParticipants || "-"}`}
            delay={0.2}
          />
        </div>
      </div>
    </section>
  );
}

function StatCard({ label, value, sublabel, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay }}
      className="rounded-2xl flex flex-col items-center justify-center gap-4 flex-1 min-w-[140px]"
      style={{ background: "#111", border: "1px solid #3b3b3b", minHeight: "158px", padding: "20px" }}
    >
      <p className="text-lg text-white font-semibold">{label}</p>
      <p className="text-5xl font-semibold leading-none" style={{ color: "#c8f135" }}>{value}</p>
      <p className="text-lg text-white font-semibold">{sublabel}</p>
    </motion.div>
  );
}
